export const medicineEntryTranslations = {
    en: {
        // Validation Messages
        dateRequired: "Date is required",
        medicineIdRequired: "Medicine ID is required",
        medicineNameRequired: "Medicine name is required",
        quantityRequired: "Quantity is required",
        quantityMustBeNumber: "Quantity must be a number",
        atLeastOneMedicine: "At least one medicine is required",
        medicinesRequired: "Medicines are required",

        // UI Labels
        medicines: "Medicines",
        addMedicine: "Add Medicine",
        medicineName: "Medicine Name *",
        quantity: "Quantity *",

        // Actions & States
        submitting: "Submitting...",
        addMedicineEntry: "Add Medicine Entry",

        // Messages
        fetchMedicinesFailed: "Failed to fetch medicines",
        addSuccess: "Medicine entry added successfully",
        addFailed: "Failed to add medicine entry",
        checkMedicineEntries: "Please check medicine entries",
    },
    mr: {
        // Validation Messages
        dateRequired: "तारीख आवश्यक आहे",
        medicineIdRequired: "औषध आयडी आवश्यक आहे",
        medicineNameRequired: "औषधाचे नाव आवश्यक आहे",
        quantityRequired: "प्रमाण आवश्यक आहे",
        quantityMustBeNumber: "प्रमाण संख्या असणे आवश्यक आहे",
        atLeastOneMedicine: "किमान एक औषध आवश्यक आहे",
        medicinesRequired: "औषधे आवश्यक आहेत",

        // UI Labels
        medicines: "औषधे",
        addMedicine: "औषध जोडा",
        medicineName: "औषधाचे नाव *",
        quantity: "प्रमाण *",

        // Actions & States
        submitting: "सबमिट करत आहे...",
        addMedicineEntry: "औषध नोंद जोडा",

        // Messages
        fetchMedicinesFailed: "औषधे मिळवण्यात अयशस्वी",
        addSuccess: "औषध नोंद यशस्वीरित्या जोडली",
        addFailed: "औषध नोंद जोडण्यात अयशस्वी",
        checkMedicineEntries: "कृपया औषध नोंदी तपासा",
    }
};
